import { Paper } from '@mantine/core';
import { SettingsBlock } from '@repo/common/components';
import { IconButton, ResourceIcon, Text } from '@repo/foundations';

interface SchemaChangeBlockProps {
	onSchemaDelete: () => void;
}

function SchemaChangeBlock({ onSchemaDelete }: SchemaChangeBlockProps) {
	return (
		<Paper radius="md">
			<SettingsBlock
				leftComponent={<ResourceIcon iconName="schema" />}
				title={
					<Text size="sm" weight="semibold">
						Schemas are changed
					</Text>
				}
				rightComponentHover={
					<IconButton
						iconName="x"
						onClick={onSchemaDelete}
						variant="tertiary"
						tooltip="Remove trigger"
						includeOffset
					/>
				}
				variant="tertiary"
			/>
		</Paper>
	);
}

export default SchemaChangeBlock;
